import { cn } from "@utils/tw"

export const Select = ({
  label,
  options,
  value,
  onChange,
  className,
  innerClassName,
}: {
  label?: string
  options: { value?: string; label: string }[]
  value?: string
  onChange?: (value: any) => void
  className?: string
  innerClassName?: string
}) => {
  return (
    <div className={cn("flex flex-col gap-1 relative shrink-0", className)}>
      <div className="relative w-fit">
        <select
          value={value}
          onChange={(e) => onChange?.(e.target.value)}
          className={cn(
            "w-fit py-3 md:py-2 pl-4 md:pl-3 pr-7 md:pr-6 rounded-sm bg-slate200 border-none type-mono-xs-regular text-slate950 appearance-none",
            innerClassName,
          )}
        >
          {label && <option value="">{label}</option>}
          {options.map((option, ox) => (
            <option key={`${option.value}${ox}`} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        <svg
          className="w-4 h-4 md:w-3 md:h-3 absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none"
          viewBox="0 0 12 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5.5 8.00024L2 4.757L2.81667 4.00024L5.5 6.48673L8.18333 4.00024L9 4.757L5.5 8.00024Z"
            fill="currentColor"
          />
        </svg>
      </div>
    </div>
  )
}
